export enum MaterialGroupOptionsEnum {
  SELECT_MATERIAL = 'Select Material',
}
